import { Axios } from '@src/api/axios/Axios';
import AxiosApi = Axios.AxiosApi;
import { Command } from '@src/constants/Constants';
import IAxiosBaseResponse = Axios.IAxiosBaseResponse;
import { Utils } from '@src/utils/Utils';
import { M } from '@src/controllers/M';
const MANS_ENDPOINT: string = Utils.getBodyData('mans');

export default class UserApi extends AxiosApi {
    public static async getStatus(): Promise<
        {
            isAuthorized: boolean;
            username: string;
        }
    > {
        const response = await this.get(
            `${MANS_ENDPOINT}active-user-status.json`,
        );
        const isAuthorized: boolean =
            response.successful && response.data.is_authorized === 'yes';
        const username: string = response.data.username || '';

        return {
            isAuthorized,
            username,
        };
    }

    public static async changePin(
        NUMBER: string,
    ): Promise<IAxiosBaseResponse & { isPrivate: boolean }> {
        const response = await this.post(Command.CHANGE_PIN, { NUMBER });
        return {
            isPrivate: true,
            ...response,
        };
    }

    public static async resetPassword(
        query: string,
    ): Promise<
        IAxiosBaseResponse & {
            isPrivate: boolean;
        }
    > {
        const response = await this.post(
            Command.RECOVER_PASSWORD,
            { query },
            M.Config.getResetPasswordEndPoint(),
        );
        return {
            isPrivate: response.data.private === '1',
            ...response,
        };
    }

    public static async logout(): Promise<IAxiosBaseResponse> {
        return await this.get(M.Config.getLogOutUrl());
    }

    constructor() {
        super();
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/api/UserApi.ts